// extracted by mini-css-extract-plugin
export var aboveInput = "_ky-0";
export var actionButton = "_ky-5";
export var actionButtonContainer = "_ky-1";
export var actionIcon = "_ky-6";
export var aiInfoContainer = "_ky-2";
export var attachmentWrapper = "_ky-7";
export var bold = "_ky-3";
export var checkIcon = "_ky-8";
export var clickingRecipientBar = "_ky-11";
export var commentThreadSwitch = "_ky-a";
export var draftImage = "_ky-b";
export var draftImageContainer = "_ky-c";
export var draftImages = "_ky-e";
export var editButton = "_ky-g";
export var editor = "_ky-f";
export var editorContainer = "_ky-y";
export var editorErrorTooltipWrapper = "_ky-9";
export var headerDivider = "_ky-h";
export var icon = "_ky-i";
export var info = "_ky-j";
export var internal = "_ky-n";
export var internalDivider = "_ky-k";
export var internalMessage = "_ky-l";
export var messageInputCard = "_ky-m";
export var messageInputForm = "_ky-o";
export var messageInputFormInternal = "_ky-p";
export var options = "_ky-q";
export var publicMessageCustomer = "_ky-s";
export var publicMessageMerchant = "_ky-r";
export var removeImageButton = "_ky-d";
export var replyButtons = "_ky-t";
export var showSignatureButton = "_ky-u";
export var spinner = "_ky-v";
export var verticalButtonDivider = "_ky-4";
export var visibilitySelector = "_ky-w";
export var warning = "_ky-x";
export var wrappingText = "_ky-z";
export var writingInternalNoteTopBorder = "_ky-10";